import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEnhancedAuth } from '../../contexts/EnhancedAuthContext';
import { useNoSidebar } from '../../hooks/useNoSidebar';
import styles from '../../styles/UnpaidAgency.module.css';

const UnpaidAgencyFlow: React.FC = () => {
  useNoSidebar();
  const navigate = useNavigate();
  const { userDetails } = useEnhancedAuth();

  const handleContactSupport = () => {
    navigate('/contact-support');
  };

  const handleMakePayment = () => {
    navigate('/payment-retry');
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          <span className={styles.warningIcon}>⚠️</span>
        </div>
        
        <h1 className={styles.title}>Agency Payment Required</h1>
        
        <p className={styles.description}>
          Welcome back! Your agency "{userDetails?.agency?.companyName}" requires payment 
          to access RealtyGenie services.
        </p>
        
        {userDetails?.agency?.paidUntil && (
          <p className={styles.expiryInfo}>
            Previous payment was valid until: {new Date(userDetails.agency.paidUntil).toLocaleDateString()}
          </p>
        )}
        
        <div className={styles.actionButtons}>
          <button 
            onClick={handleContactSupport}
            className={styles.contactButton}
          >
            Contact Support
          </button>
          <button 
            onClick={handleMakePayment}
            className={styles.paymentButton}
          >
            Make Payment
          </button>
        </div>
        
        <p className={styles.helpText}>
          Need assistance? Our support team is here to help you get back up and running.
        </p>
      </div>
    </div>
  );
};

export default UnpaidAgencyFlow;
